import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbarr from "../../components/navbar/Navbarr";
import Welcome from "../welcome/Welcome";
import "./Hero.css";

function Hero() {
  return (
    <div className="hero-container">
      <Navbarr />
      <div className="title-box">
        <h1 className="title-hero">RENT - STÄD</h1>
        <h2 className="sub-title">Vi gör livet lite enklare för dig</h2>
        <Nav.Link href="#contact">
          <button className="btn-hero">kontakta oss</button>
        </Nav.Link>
      </div>
      <Welcome />
    </div>
  );
}

export default Hero;
